import React from "react";

import { Box, Grid, useMediaQuery } from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";

import { SubchapterProps } from "components/customer/insights/Subchapter";
import SubchapterHeader from "components/customer/insights/SubchapterHeader";

import InsightPerformance from "./InsightPerformance";

const CompanyHealthSubchapter: React.FC<SubchapterProps> = (props) => {
    const { id, number, title, subtitle, subchapterRef, dataCy } = props;
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const scrollMarginTop = isMobile ? theme.spacing(18) : theme.spacing(3);

    return (
        // @ts-ignore
        <Box id={id} paddingBottom={8} ref={subchapterRef} data-cy={dataCy} style={{ scrollMarginTop: scrollMarginTop }}>
            <Grid container spacing={2}>
                <Grid item md={4} xs={12}>
                    <SubchapterHeader number={number} title={title} subtitle={subtitle} />
                </Grid>
                <Grid item md={8} xs={12}>
                    <InsightPerformance />
                </Grid>
            </Grid>
        </Box>
    );
};

export default CompanyHealthSubchapter;
